import { render, staticRenderFns } from "./carInfo.vue?vue&type=template&id=bc484cc8&scoped=true"
import script from "./carInfo.vue?vue&type=script&lang=js"
export * from "./carInfo.vue?vue&type=script&lang=js"
import style0 from "./carInfo.vue?vue&type=style&index=0&id=bc484cc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc484cc8",
  null
  
)

export default component.exports